// Libraries
import { observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";

// Custom
import { PlygeneMouldedModel, PlygeneMouldedModelDTO } from "./PlygeneProductModels/PlygeneMoulded";
import { PlygeneStandardModel, PlygenStandardModelDTO } from "./PlygeneProductModels/PlygeneStandard";

export class PlygeneProductsModel extends ModelBase<PlygeneProductsModel, PlygeneProductsModelDTO> {
    private plygeneMouldedModel: PlygeneMouldedModel;
    private plygeneStandardModel: PlygeneStandardModel;

    constructor() {
        super();

        this.plygeneMouldedModel = new PlygeneMouldedModel();
        this.plygeneStandardModel = new PlygeneStandardModel();

        this.products.push({ title: "Bespoke moulded components", value: "id_plygenemoulded" });
        this.products.push({ title: "Standard stop ends and outlets", value: "id_plygenestandard" });

        this.productSelection = this.products[0];
    }

    // #region Model Properties

    public get PlygeneMouldedModel(): PlygeneMouldedModel {
        return this.plygeneMouldedModel;
    }

    public get PlygeneStandardModel(): PlygeneStandardModel {
        return this.plygeneStandardModel;
    }

    @observable
    public products = observable<any>([]);

    @observable
    public productSelection: any = undefined;

    // #endregion Model Properties

    public fromDto(model: PlygeneProductsModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): PlygeneProductsModelDTO {
        return {
            plygeneMoulded: this.productSelection.value === "id_plygenemoulded" ? this.PlygeneMouldedModel.toDto() : undefined,
            plygeneStandard: this.productSelection.value === "id_plygenestandard" ? this.plygeneStandardModel.toDto() : undefined,
        };
    }
}

export interface PlygeneProductsModelDTO {
    plygeneMoulded?: PlygeneMouldedModelDTO;
    plygeneStandard?: PlygenStandardModelDTO;
}
